import { render, staticRenderFns } from "./ucmenu.vue?vue&type=template&id=3fb75a46&scoped=true"
import script from "./ucmenu.vue?vue&type=script&lang=js"
export * from "./ucmenu.vue?vue&type=script&lang=js"
import style0 from "./ucmenu.vue?vue&type=style&index=0&id=3fb75a46&prod&lang=css"
import style1 from "./ucmenu.vue?vue&type=style&index=1&id=3fb75a46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb75a46",
  null
  
)

export default component.exports